<template>
  <form>
    <b-row cols="1" cols-lg="2">
      <b-col>
        <SelectorForm
          selectLabel="Estado"
          :selectFormOptions="selectFormOptions"
          @handlerSelect="onChangeStatus"
          :selectedOption="this.picData.status"
          :isValid="this.picDataValidation.status"
          :disabled="!this.$store.getters.hasAdminPermission"
        />
      </b-col>
      <b-col>
        <b-form-group
          label="Fecha Realización"
          :hidden="!this.$store.getters.hasAdminPermission"
        >
          <b-form-datepicker
            id="receivedDate"
            v-model="receivedDate"
            placeholder="Fecha Realización"
            @context="onChangeReceivedDate"
            :date-format-options="{
              day: 'numeric',
              month: 'numeric',
              year: 'numeric'
            }"
            start-weekday="1"
            :class="this.picDataValidation.receivedDate == '' ? 'has-error' : ''"
            :reset-button="true"
            label-reset-button="Borrar fecha seleccionada"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row cols="1" cols-lg="2">
      <b-col>
        <b-form-group
          :hidden="!this.$store.getters.hasAdminPermission"
          label="Fecha Revisión"
        >
          <b-form-datepicker
            id="revisedDate"
            v-model="revisedDate"
            placeholder="Fecha Revisión"
            @context="onChangeRevisedDate"
            :date-format-options="{
              day: 'numeric',
              month: 'numeric',
              year: 'numeric'
            }"
            start-weekday="1"
            :reset-button="true"
            label-reset-button="Borrar fecha seleccionada"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          :hidden="!this.$store.getters.hasAdminPermission"
          label="Fecha Aprobación"
        >
          <b-form-datepicker
            id="approvedDate"
            v-model="approvedDate"
            placeholder="Fecha Aprobación"
            @context="onChangeApprovedDate"
            :date-format-options="{
              day: 'numeric',
              month: 'numeric',
              year: 'numeric'
            }"
            start-weekday="1"
            :reset-button="true"
            label-reset-button="Borrar fecha seleccionada"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import SelectorForm from '@/components/atoms/Forms/SelectorForm/SelectorForm.vue';
import { getStatusSelectorOptionsPIC } from '@/helpers/StatusHelper';

export default {
  name: 'FormPicContent',
  components: { SelectorForm },
  props: {
    handlePicData: {},
    picData: {
      type: Object,
      default: () => {},
    },
    picDataValidation: Object,
  },
  data() {
    return {
      selectFormOptions: getStatusSelectorOptionsPIC(this.$store.getters.isSupplier),
      receivedDate: this.picData.receivedDate,
      revisedDate: this.picData.revisedDate,
      approvedDate: this.picData.approvedDate,
    };
  },
  methods: {
    onChangeStatus(data) {
      this.$emit('onChangeStatus', data);
    },
    onChangeReceivedDate(data) {
      if (data.selectedDate !== null) {
        this.$emit('onChangeReceivedDate', data.activeYMD);
      } else {
        this.$emit('onChangeReceivedDate', null);
      }
    },
    onChangeRevisedDate(data) {
      if (data.selectedDate !== null) {
        this.$emit('onChangeRevisedDate', data.activeYMD);
      } else {
        this.$emit('onChangeRevisedDate', null);
      }
    },
    onChangeApprovedDate(data) {
      if (data.selectedDate !== null) {
        this.$emit('onChangeApprovedDate', data.activeYMD);
      } else {
        this.$emit('onChangeApprovedDate', null);
      }
    },
    // onChangeReceivedDate(data) {
    //   if (data.selectedDate !== null) {
    //     this.$emit('onChangeReceivedDate', data.activeYMD);
    //   }
    // },
  },
};
</script>

<style lang="sass" scoped>
@import './FormContent.sass'
</style>
